var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.035 8.641 3.996-4.58a1.286 1.286 0 0 1 1.938 0l3.996 4.58 3.813-2.408a1.287 1.287 0 0 1 1.956 1.291l-1.812 11.322a1.821 1.821 0 0 1-1.798 1.534H4.876c-.894 0-1.657-.65-1.798-1.534L1.266 7.524a1.286 1.286 0 0 1 1.956-1.291zm-4.213-.886 1.737 10.854a.321.321 0 0 0 .317.271h14.248a.321.321 0 0 0 .317-.271l1.737-10.854-3.567 2.252a1.287 1.287 0 0 1-1.656-.241L12 5.232 8.045 9.766c-.417.477-1.12.58-1.656.241L2.822 7.755z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.037 15.129a.75.75 0 0 1 0 1.5H3.963a.75.75 0 0 1 0-1.5z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.ffed2a954e22efaff4a78240e03f7615.svg";
export { ForwardRef as ReactComponent };